import { Box, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { ActionButton } from "../../../../talentProfile/styles";
import { SpinnerButton } from "../../../../../common/components/functional/spinnerButton/SpinnerButton";
import { FulfillmentStatus } from "../../../orderAPI";
import useIsLoading from "../../../../../hooks/useIsLoading";
import { ReactComponent as CheckMark } from "../../../../../common/icons/check-filled.svg";
import { useTranslation } from "react-i18next";
import { ConfirmationDialog } from "../../../../../common/components/functional/confirmationDialog/ConfirmationDialog";
import { useState } from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { selectOrderRowById } from "../../../orderRowsDetailedSlice";
import { useParams } from "react-router-dom";

type Props = {
  saveAction: () => void;
  cancelAction: () => void;
};

export const Buttons = ({ saveAction, cancelAction }: Props) => {
  const { t } = useTranslation("order");
  const isLoading = useIsLoading(["orderRows"]);
  const { bundleId } = useParams();
  const {
    watch,
    formState: { isDirty, isValid },
  } = useFormContext();
  const { edit, isReadOnly } = watch();

  const order = useAppSelector((state) =>
    selectOrderRowById(state, bundleId!!),
  );

  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState<boolean>(false);

  const submitDisabled = isReadOnly || !isDirty || !isValid;

  return (
    <>
      <FormSection disablePaddingBottom noBorder>
        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <ActionButton
              variant="outlined"
              color="error"
              disabled={
                isReadOnly ||
                order?.status?.fulfillmentStatus === FulfillmentStatus.Partial
              }
              onClick={
                edit ? cancelAction : () => setIsConfirmationDialogOpen(true)
              }
            >
              {edit ? t("order:cancelOrder") : t("common:delete")}
            </ActionButton>
          </Box>
          <Box>
            <SpinnerButton
              startIcon={<CheckMark />}
              color="primary"
              variant="contained"
              onClick={saveAction}
              label={edit ? t("order:saveOrder") : t("order:saveOrderRow")}
              isLoading={isLoading}
              disabled={submitDisabled}
              sx={{
                height: "36px",
                borderRadius: "20px",
              }}
            />
          </Box>
        </Grid>
      </FormSection>
      <ConfirmationDialog
        title={t("order:removeOrderRow")}
        contentText={t("order:confirmRemoveOrderRow")}
        cancelText={t("common:cancel")}
        confirmText={t("common:delete")}
        isOpen={isConfirmationDialogOpen}
        onConfirm={() => {
          cancelAction();
          setIsConfirmationDialogOpen(false);
        }}
        onCancel={() => setIsConfirmationDialogOpen(false)}
      />
    </>
  );
};
